import { lazy } from "react";
import LazyRoute from "../components/Common/LazyRoute";
import ROUTES from "./ROUTES";

const WorkspaceJobsTable = lazy(() => import("../components/Workspace/WorkspaceJobsTable"));

export default [
  {
    path: ROUTES.WORKSPACE.JOBS,
    element: <LazyRoute><WorkspaceJobsTable /></LazyRoute>,
  },
];
